// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"41":"error","413":"company-files"}[chunkId] + "." + {"41":"bfff4a27","413":"4b8b0018"}[chunkId] + ".css";
};